<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 467.07 467.08"
  >
    <path
      class="fill-white stroke-0"
      d="M422.21,233.54s-68.84-87.37-217.8-.02C65.08,315.25,0,231.65,0,231.65l44.86,49.45s65.53,99.41,229.32.67c117.24-70.69,192.89,1.22,192.89,1.22l-44.86-49.45Z"
    />
    <path
      class="fill-[#0d1238] stroke-0"
      d="M.45,231.59s67.68,83.51,218.77-7.75c125.19-75.6,202.99,9.22,202.99,9.22L266.21,61.27h-14.74L201.73,0l-75.51,100.77h-16.21L.45,231.59Z"
    />
    <path
      class="fill-white stroke-0"
      d="M201.74,13.37l-70.32,93.99h-17.36l-40.19,48.5,56.29-31.79,45.49,21.46,26.09-41.19V13.37Z"
    />
    <path
      class="fill-white stroke-0"
      d="M295.72,104.28l-33.19-36.64h-36.89l70.08,36.64Z"
    />
    <path
      class="fill-[#0978a7] stroke-0"
      d="M422.21,233.07s-62.39-94.47-211.34-7.12C71.53,307.67,0,231.18,0,231.18c0,0,68.76,106.66,232.54,7.91,117.24-70.69,189.68-6.02,189.68-6.02"
    />
    <path
      class="fill-[#0978a7] stroke-0"
      d="M445.22,257.79s-62.39-94.47-211.35-7.11c-139.34,81.72-210.86,5.22-210.86,5.22,0,0,68.75,106.65,232.52,7.91,117.25-70.69,189.69-6.02,189.69-6.02"
    />
    <path
      class="fill-[#0978a7] stroke-0"
      d="M467.07,282.52s-62.39-94.47-211.35-7.14c-139.34,81.73-210.87,5.25-210.87,5.25,0,0,68.76,106.65,232.54,7.91,117.24-70.69,189.69-6.02,189.69-6.02"
    />
    <path
      class="fill-[#1c2348] stroke-0"
      d="M270,374.85c0,3.27,1.37,4.43,3.59,4.43,1.16,0,2.11-.32,3.05-.73v10.23c-2,1.27-4.65,1.79-8.02,1.79-6.22,0-10.01-2.42-11.61-7.7-2.21,6.01-7.48,8.03-14.13,8.03-8.66,0-14.36-5.07-14.36-13.41,0-10.88,8.76-16.78,27.53-15.72v-4.65c0-4.22-1.79-6.75-5.69-6.75s-5.92,2.64-6.12,7.18l-14.03-2.64c.73-10.34,9.49-15.18,20.68-15.18,12.13,0,19.09,5.27,19.09,16.13v18.99ZM256.07,369.36c-9.91-.31-13.4,2.32-13.4,6.65,0,2.85,2.01,4.84,5.38,4.84,3.7,0,8.02-1.79,8.02-6.53v-4.96Z"
    />
    <path
      class="fill-[#1c2348] stroke-0"
      d="M313.14,355.44c-1.8-.64-3.27-.85-5.49-.85-5.59,0-12.45,2.75-12.45,12.76v22.27h-14.14v-48.75h12.23l1.69,13.41c2.13-8.43,6.86-15.19,19.73-14.46l-1.58,15.62Z"
    />
    <path
      class="fill-[#1c2348] stroke-0"
      d="M359.68,376.54c-1.8,9.81-10.23,14.36-20.57,14.36-14.14,0-23.53-9.19-23.53-25.43s9.39-25.74,23.64-25.74c11.61,0,18.98,6.22,19.72,16.04l-11.92,3.26c-.73-5.17-3.16-8.22-7.91-8.22-6.33,0-9.82,5.58-9.82,14.44,0,9.29,3.7,14.78,10.03,14.78,3.81,0,6.65-1.9,7.92-7.49l12.45,4.01Z"
    />
    <path
      class="fill-[#1c2348] stroke-0"
      d="M398.68,387.72c-4.11,2.11-9.18,3.16-14.99,3.16-9.71,0-16.04-4.54-16.04-15.72v-23.42h-7.06v-10.88h7.17v-10.33l14.15-1.68v12.01h14.45v10.88h-14.56v20.25c0,5.17,2.02,6.86,5.91,6.86,3.06,0,5.7-1.05,8.54-3.04l2.43,11.91Z"
    />
    <path
      class="fill-[#1c2348] stroke-0"
      d="M410.11,317.77c4.97,0,8.76,2.85,8.76,8.24s-3.79,8.02-8.76,8.02-8.54-2.85-8.54-8.02,3.79-8.24,8.54-8.24M417.19,389.62h-14.15v-48.74h14.15v48.74Z"
    />
    <path
      class="fill-[#1c2348] stroke-0"
      d="M467.07,376.54c-1.79,9.81-10.23,14.36-20.58,14.36-14.13,0-23.52-9.19-23.52-25.43s9.39-25.74,23.64-25.74c11.61,0,18.98,6.22,19.73,16.04l-11.93,3.26c-.74-5.17-3.16-8.22-7.92-8.22-6.32,0-9.81,5.58-9.81,14.44,0,9.29,3.69,14.78,10.03,14.78,3.8,0,6.64-1.9,7.92-7.49l12.45,4.01Z"
    />
    <path
      class="fill-[#1c2348] stroke-0"
      d="M41.47,451.03c0,3.28,1.38,4.43,3.58,4.43,1.17,0,2.12-.32,3.07-.73v10.23c-2,1.26-4.65,1.79-8.02,1.79-6.23,0-10.03-2.42-11.61-7.7-2.21,6.01-7.48,8.03-14.13,8.03-8.66,0-14.35-5.07-14.35-13.41,0-10.88,8.76-16.78,27.53-15.72v-4.65c0-4.22-1.79-6.74-5.69-6.74s-5.91,2.63-6.12,7.17l-14.03-2.64c.74-10.34,9.5-15.18,20.68-15.18,12.13,0,19.09,5.27,19.09,16.13v18.99ZM27.53,445.55c-9.9-.3-13.39,2.32-13.39,6.65,0,2.85,2,4.86,5.39,4.86,3.69,0,8.01-1.8,8.01-6.55v-4.96Z"
    />
    <path
      class="fill-[#1c2348] stroke-0"
      d="M84.28,395.33h14.14v70.47h-12.24l-1.79-8.44c-1.8,7.4-7.92,9.71-15.2,9.71-10.77,0-19.41-8.54-19.41-24.58s7.8-26.58,21.72-26.58c6.23,0,11.51,2.95,12.77,7.59v-28.17ZM84.39,436.48c0-7.18-4.65-10.13-9.49-10.13-5.6,0-10.99,4-10.99,15.51,0,9.17,4.12,14.36,10.77,14.36,4.85,0,9.71-3.6,9.71-10.66v-9.08Z"
    />
    <path
      class="fill-[#1c2348] stroke-0"
      d="M101.67,417.06h14.98l6.66,22.16c2.42,8.02,3.27,15.83,3.27,15.83h.41s1.06-7.91,3.48-15.72l7.07-22.27h14.46l-17.73,48.75h-15.5l-17.09-48.75Z"
    />
    <path
      class="fill-[#1c2348] stroke-0"
      d="M182.97,449.56l12.03,4.11c-2.53,9.92-11.29,13.4-20.89,13.4-13.93,0-23.52-9.18-23.52-24.89,0-16.78,9.07-26.28,23.74-26.28,13.81,0,20.57,9.09,20.57,21.64,0,2.09-.22,4.32-.64,6.31h-30.06c.32,7.49,3.8,12.35,10.23,12.35,3.8,0,6.96-1.47,8.54-6.64M181.38,436.05c.11-.64.11-1.06.11-1.69,0-4.54-2.64-8.02-7.71-8.02s-8.64,4-9.16,9.71h16.77Z"
    />
    <path
      class="fill-[#1c2348] stroke-0"
      d="M215.06,426.46c2.64-7.28,8.13-10.55,15.62-10.55s14.35,4.43,14.35,15.39v34.51h-14.14v-29.21c0-5.39-1.48-8.88-6.54-8.88-4.53,0-8.86,2.54-8.86,11.3v26.79h-14.14v-48.74h12.03l1.68,9.4Z"
    />
    <path
      class="fill-[#1c2348] stroke-0"
      d="M286.45,463.91c-4.11,2.12-9.17,3.16-14.98,3.16-9.71,0-16.03-4.54-16.03-15.72v-23.42h-7.07v-10.87h7.18v-10.34l14.13-1.68v12.02h14.45v10.87h-14.55v20.26c0,5.17,2,6.86,5.91,6.86,3.05,0,5.69-1.06,8.54-3.07l2.42,11.93Z"
    />
    <path
      class="fill-[#1c2348] stroke-0"
      d="M319.83,456.73c-1.7,6.66-6.12,10.35-15.09,10.35s-14.67-4.44-14.67-15.73v-34.29h14.14v30.27c0,5.81,1.8,9.09,6.65,9.09s8.76-3.8,8.76-13.2v-26.16h14.13v48.75h-12.23l-1.69-9.09Z"
    />
    <path
      class="fill-[#1c2348] stroke-0"
      d="M374.54,431.63c-1.8-.64-3.27-.85-5.49-.85-5.6,0-12.46,2.75-12.46,12.76v22.27h-14.13v-48.74h12.23l1.7,13.39c2.1-8.43,6.86-15.18,19.71-14.45l-1.57,15.62Z"
    />
    <path
      class="fill-[#1c2348] stroke-0"
      d="M409.36,449.56l12.03,4.11c-2.54,9.92-11.3,13.4-20.89,13.4-13.93,0-23.53-9.18-23.53-24.89,0-16.78,9.08-26.28,23.73-26.28,13.83,0,20.58,9.09,20.58,21.64,0,2.09-.2,4.32-.62,6.31h-30.06c.3,7.49,3.79,12.35,10.23,12.35,3.8,0,6.96-1.47,8.54-6.64M407.78,436.05c.11-.64.11-1.06.11-1.69,0-4.54-2.64-8.02-7.7-8.02s-8.65,4-9.19,9.71h16.78Z"
    />
    <path
      class="fill-[#1c2348] stroke-0"
      d="M435.63,449.88c1.06,5.28,4.84,7.28,9.49,7.28,3.91,0,6.64-1.38,6.64-4.22s-1.9-4-6.22-5.06l-7.17-1.68c-8.55-2.23-12.46-7.08-12.46-14.46,0-12.35,9.81-15.83,19.83-15.83,11.6,0,18.57,4.22,19.31,13.71l-13.2,1.9c-.52-3.91-2.72-5.17-6.74-5.17-3.27,0-5.49,1.47-5.49,4.01s1.47,3.8,4.74,4.43l6.86,1.47c9.92,2.12,14.55,7.39,14.55,15.72,0,10.87-8.97,15.1-20.88,15.1s-18.99-3.39-20.89-12.56l11.61-4.65Z"
    />
  </svg>
</template>
